import type { CVData } from '~/types/cv'

/**
 * The sample CV behind every showcase preview (/demo today).
 *
 * Shared with the server on purpose: `/api/pdf/preview` renders the free
 * watermark from the session and never from the request body, or any visitor
 * could ask for a clean print of their own CV. A showcase still has to be
 * clean — it sells the templates, not the free plan — so the request says
 * "render the sample" and the server renders *this* CV, which is made-up data
 * nobody is paying to get watermark-free.
 */
export const DEMO_CV_DATA: CVData = {
  name: 'Alexandra Johnson',
  title: 'Full-Stack Developer',
  /*
   * Stated rather than left out: CVBusinessWebTemplate falls back to Czech when
   * a CV carries no language, which showed an English sample under Czech headings.
   */
  cvLanguage: 'en',
  aboutMe: 'Passionate full-stack developer with 7+ years of experience building scalable web applications. Expertise in modern JavaScript frameworks, cloud technologies, and agile development methodologies. Proven track record of leading cross-functional teams and delivering high-quality software solutions.',
  photoUrl: 'https://www.inmyresume.com/_vercel/image?url=%2FAdam.png&w=320&q=80',
  experiences: [
    {
      title: 'Senior Software Engineer',
      company: 'TechCorp Solutions',
      startDate: '2021-03',
      endDate: '',
      description: 'Lead development of microservices architecture serving 2M+ users. Implemented CI/CD pipelines, reducing deployment time by 60%. Mentored junior developers and established coding standards.',
    },
    {
      title: 'Full-Stack Developer',
      company: 'Digital Innovations Inc.',
      startDate: '2019-06',
      endDate: '2021-02',
      description: 'Developed responsive web applications using React and Express.js. Collaborated with UX designers to implement pixel-perfect interfaces. Optimized database queries, improving performance by 40%.',
    },
    {
      title: 'Frontend Developer',
      company: 'StartupXYZ',
      startDate: '2017-09',
      endDate: '2019-05',
      description: 'Built interactive user interfaces for SaaS platform. Implemented responsive design principles and cross-browser compatibility. Worked closely with product team to define user requirements.',
    },
  ],
  education: [
    {
      degree: 'Master of Science in Computer Science',
      school: 'Stanford University',
      startDate: '2015-09',
      endDate: '2017-06',
    },
    {
      degree: 'Bachelor of Science in Software Engineering',
      school: 'University of California, Berkeley',
      startDate: '2011-09',
      endDate: '2015-06',
    },
  ],
  technicalSkills: [
    'JavaScript',
    'React',
    'Node.js',
    'AWS Cloud Services',
    'Python',
    'Docker',
    'Kubernetes',
  ],
  softSkills: [
    'Team Leadership',
    'Communication',
    'Problem Solving',
    'Project Management',
  ],
  languages: [
    { name: 'English', level: 'Native' },
    { name: 'Spanish', level: 'Professional' },
  ],
  contact: {
    email: 'alexandra.johnson@email.com',
    phone: '+1 (555) 123-4567',
    website: 'https://inmyresume.com',
  },
  websites: [
    { name: 'Portfolio', url: 'https://inmyresume.com' },
  ],
  showQRCode: true,
}
